import {
  RiHome5Line,
  RiMenuLine,
  RiDownloadCloud2Line,
  RiStore2Line,
} from "react-icons/ri";
import { BiBookOpen } from "react-icons/bi";
import { Link, useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { RiMegaphoneLine, RiFileList3Line } from "react-icons/ri";
import { useAuth } from "../../../hooks/AuthContext";
import { useOnboard } from "../../../hooks/OnboardContext";
import { i18n } from "../../../localization/i18n";
import { customerSituations } from "../../../utils/constants";
import { MenuButton, MenuItemContainer } from "../styles";

interface MenuListProps {
  extendedMode: boolean;
  setExtendedMode?: (val: boolean) => void;
}

export const FixiterMenuList = ({ extendedMode }: MenuListProps) => {
  const { user } = useAuth();
  const { licensee } = useOnboard();
  const location = useLocation();

  const tooltipProps = {
    tooltip: {
      sx: {
        backgroundColor: "var(--dark-gray)",
        color: "var(--white)",
        fontSize: "14px",
        fontWeight: "500",
        padding: "8px 14px",
        borderRadius: "6px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
      }
    },
    arrow: {
      sx: {
        color: "var(--dark-gray)"
      }
    }
  };

  const hasProviderId = !!licensee?.provider_id;
  const isActive = licensee?.situation === customerSituations.active;
  const isPaymentPendingOrActive = licensee?.situation === customerSituations.active || licensee?.situation === "payment_pending";

  return (
    <>
      <MenuItemContainer>
        <Link to="/fixiter/dashboard">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.home") || "Início"}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                isActive={location.pathname.includes("/fixiter/dashboard")}
                disabled={!isPaymentPendingOrActive}
              >
                <div className="content">
                  <RiHome5Line size={24} />
                  <span>{`${i18n.t("sidebar.home") || "Início"}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      {hasProviderId ? (
        <>
          <MenuItemContainer>
            <Link to={isActive ? "/orders" : "/fixiter/dashboard"}>
              <Tooltip 
                title={extendedMode ? "" : `${i18n.t("sidebar.requests")}`} 
                placement="right" 
                arrow 
                disableHoverListener={extendedMode}
                componentsProps={tooltipProps}
              >
                <span style={{ display: 'block' }}>
                  <MenuButton
                    extendedMode={extendedMode}
                    isActive={location.pathname.includes("/orders")}
                    disabled={!isActive}
                  >
                    <div className="content">
                      <RiMenuLine size={24} />
                      <span>{`${i18n.t("sidebar.requests")}`}</span>
                    </div>
                  </MenuButton>
                </span>
              </Tooltip>
            </Link>
          </MenuItemContainer>

          <MenuItemContainer>
            <Link to={isActive ? "/solutions" : "/fixiter/dashboard"}>
              <Tooltip 
                title={extendedMode ? "" : `${i18n.t("sidebar.solutions")}`} 
                placement="right" 
                arrow 
                disableHoverListener={extendedMode}
                componentsProps={tooltipProps}
              >
                <span style={{ display: 'block' }}>
                  <MenuButton
                    extendedMode={extendedMode}
                    isActive={location.pathname.includes("/solutions")}
                    disabled={!isActive}
                  >
                    <div className="content">
                      <RiDownloadCloud2Line size={24} />
                      <span>{`${i18n.t("sidebar.solutions")}`}</span>
                    </div>
                  </MenuButton>
                </span>
              </Tooltip>
            </Link>
          </MenuItemContainer>
        </>
      ) : (
        <MenuItemContainer>
          {isActive ? (
            <a
              href="http://loja.usefixit.com.br/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <Tooltip 
                title={extendedMode ? "" : `${i18n.t("sidebar.store") || "Loja"}`} 
                placement="right" 
                arrow 
                disableHoverListener={extendedMode}
                componentsProps={tooltipProps}
              >
                <span style={{ display: 'block' }}>
                  <MenuButton extendedMode={extendedMode}>
                    <div className="content">
                      <RiStore2Line size={24} />
                      <span>{`${i18n.t("sidebar.store") || "Loja"}`}</span>
                    </div>
                  </MenuButton>
                </span>
              </Tooltip>
            </a>
          ) : (
            <Tooltip 
              title={extendedMode ? "" : `${i18n.t("sidebar.store") || "Loja"}`} 
              placement="right" 
              arrow 
              disableHoverListener={extendedMode}
              componentsProps={tooltipProps}
            >
              <span style={{ display: 'block' }}>
                <MenuButton
                  extendedMode={extendedMode}
                  disabled={true}
                >
                  <div className="content">
                    <RiStore2Line size={24} />
                    <span>{`${i18n.t("sidebar.store") || "Loja"}`}</span>
                  </div>
                </MenuButton>
              </span>
            </Tooltip>
          )}
        </MenuItemContainer>
      )}

      <MenuItemContainer>
        {isPaymentPendingOrActive ? (
          <a
            href="https://usefixit.com.br/treinamento"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Tooltip 
              title={extendedMode ? "" : `${i18n.t("sidebar.courses")}`} 
              placement="right" 
              arrow 
              disableHoverListener={extendedMode}
              componentsProps={tooltipProps}
            >
              <span style={{ display: 'block' }}>
                <MenuButton
                  extendedMode={extendedMode}
                  isActive={location.pathname.includes("/fixiter/courses")}
                >
                  <div className="content">
                    <BiBookOpen size={24} />
                    <span>{`${i18n.t("sidebar.courses")}`}</span>
                  </div>
                </MenuButton>
              </span>
            </Tooltip>
          </a>
        ) : (
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.courses")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                disabled={true}
              >
                <div className="content">
                  <BiBookOpen size={24} />
                  <span>{`${i18n.t("sidebar.courses")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        )}
      </MenuItemContainer>

      <MenuItemContainer>
        {isActive ? (
          <a
            href="https://usefixit.com.br/kit-fixiter"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Tooltip 
              title={extendedMode ? "" : `${i18n.t("sidebar.marketing") || "Marketing"}`} 
              placement="right" 
              arrow 
              disableHoverListener={extendedMode}
              componentsProps={tooltipProps}
            >
              <span style={{ display: 'block' }}>
                <MenuButton extendedMode={extendedMode}>
                  <div className="content">
                    <RiMegaphoneLine size={24} />
                    <span>{`${i18n.t("sidebar.marketing") || "Marketing"}`}</span>
                  </div>
                </MenuButton>
              </span>
            </Tooltip>
          </a>
        ) : (
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.marketing") || "Marketing"}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                disabled={true}
              >
                <div className="content">
                  <RiMegaphoneLine size={24} />
                  <span>{`${i18n.t("sidebar.marketing") || "Marketing"}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        )}
      </MenuItemContainer>

      <MenuItemContainer>
        <Link
          to={
            isActive
              ? "/fixiter/certificate"
              : "/fixiter/dashboard"
          }
        >
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.certificate") || "Certificado"}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton
                extendedMode={extendedMode}
                isActive={location.pathname.includes("/fixiter/certificate")}
                disabled={!isPaymentPendingOrActive}
              >
                <div className="content">
                  <RiFileList3Line size={24} />
                  <span>{`${i18n.t("sidebar.certificate") || "Certificado"}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>
    </>
  );
};
